import {
  GET_DRIVER_PROFILE,
  GET_DRIVER_PROFILE_ERROR,
  CREATE_DRIVER_PROFILE_SUCCESS,
  CREATE_DRIVER_PROFILE_FAILED,
  CREATE_DRIVER_PROFILE_PENDING,
  EDIT_DRIVER_PROFILE_SUCCESS
} from "../constants/DriverConstants";

const INITIAL_STATE = {
  driver: [],
  loading: true
};
const driverReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DRIVER_PROFILE:
      return {
        ...state,
        driver: action.payload,
        loading: false
      };
    case GET_DRIVER_PROFILE_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const postDriver = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE_DRIVER_PROFILE_PENDING:
      return Object.assign({}, state, { loading: true });
    case CREATE_DRIVER_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        driver: action.payload
      });
    case CREATE_DRIVER_PROFILE_FAILED:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const editDriverProfile = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_DRIVER_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        merchant: action.payload
      });
    default:
      return state;
  }
};
export default driverReducer;
